import { render, staticRenderFns } from "./SituacaoCandidatos.vue?vue&type=template&id=c44c615e&scoped=true&"
import script from "./SituacaoCandidatos.vue?vue&type=script&lang=js&"
export * from "./SituacaoCandidatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44c615e",
  null
  
)

export default component.exports